import React, { useState, useEffect } from 'react'
import "./Endsession.css"
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { showToast } from '../Utils/utils';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../Component/Loader/Loader';
import Userprofile from '../../Component/Userprofile/Userprofile';
import { Bookingsessiondetails } from '../Utils/utils';
import { Initiatecompletesession } from "../Redux/action/Completedsession";
import moment from 'moment';


const Endsession = () => {
  let location = useLocation();
  let id = new URLSearchParams(location.search).get('id')
  const navigate = useNavigate();

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [completesession, setCompleteSession] = useState(null)
  const [sessiondata, Setsessiondata] = useState(null);


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let session_id = new URLSearchParams(location.search).get('id')

  const handleBookingsesiondata = async () => {
    try {
      setLoading(true)
      const response = await Bookingsessiondetails(session_id);
      Setsessiondata(response?.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }




  const Completesession = async () => {
    try {
      setLoading(true);
      const response = await dispatch(Initiatecompletesession(session_id));
      showToast(response?.message, "success")
      handleShow();
      setCompleteSession(response?.data);
      if (response.status === 200) {
        window.location.href = `/completesession?id=${session_id}`
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const bookingsessionid = localStorage.getItem("sessionid");
    if (!id || id !== bookingsessionid) {
      navigate('/dashboard');
    } else {
      handleBookingsesiondata();
    }
  }, []);

  return (
    <>
      {loading && <Loader />}
      <body id="Endsession-top">

        <div className='Endsession-wrapper mx-auto'>
          <div className='booking-top-container p-4 d-flex justify-content-between'>
            <Userprofile />
          </div>

          <div className='enssession-info  p-3'>
            {/* End Session */}
            <div className='end-session-info mt-2 mb-auto'>
              <div className='endsession-inner p-3'>
                <div className='d-flex justify-content-between align-items-center w-100'>
                  <div className='d-flex flex-column flex-grow-1 gap-1'>
                    <span className='user-details'>{sessiondata?.member?.name ? sessiondata?.member?.name : sessiondata?.member?.full_name}</span>
                    {/* <div className='d-flex gap-1 align-items-center'>
                      <span className='user-common'>26 years</span>
                      <span className='vertical-border'></span>
                      <span className='user-common'>Male</span>
                    </div> */}
                    <span className='user-address'>{sessiondata?.member?.address}</span>
                  </div>
                  {sessiondata?.status === "ongoing" ?
                    <>
                      <div className="slot-Onway-conatiner p-1">
                        <span className="slot-Onway-progressbar">Ongoing</span>
                      </div>
                    </> : <>
                      <div className='progress-status-completed text-center flex-shrink-0 p-1'>
                        <span className='status-text'>Completed</span>
                      </div>
                    </>
                  }


                </div>

                <div class="schedule-details-container d-flex flex-column  p-3 mt-3">
                  <span className='booking-id'>Booking ID - {sessiondata?.booking?.booking_number}</span>
                  <div class="Session-details d-flex  flex-sm-row justify-content-between gap-5 gap-sm-0 w-100 mt-2">
                    <div>
                      <span class="text">Session Time</span>
                      <div class="d-flex justify-content-between">
                        <span class="date">  {`${moment(sessiondata?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(sessiondata?.toTime, "HH:mm:ss").format("hh:mm A")}`}</span>
                      </div>
                    </div>
                    <div>
                      <span class="text">Service</span>
                      <div class="d-flex justify-content-between">
                        <span class="date">{sessiondata?.interest?.name}</span>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>


            {/* close End Session */}



            <div className='btn-conatiner d-sm-block d-lg-none d-md-none'>
              <button className='submit-btn' type='submit' onClick={handleShow}>
                <span className='submit-btn-text'>End Session</span>
              </button>
            </div>
            <div className='btn-conatiner-lg d-none d-lg-block d-md-block p-3' onClick={handleShow}>
              <button className='submit-btn-lg' type='submit'>
                <span className='submit-btn-text'>End Session</span>
              </button>
            </div>


          </div>

          {/* start sesstion modal */}
          <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
          >
            <div onClick={handleClose}>
              <img className="position-absolute top-0 end-0 m-3 close-btn img-fluid" src="/Images/close.svg" />
            </div>
            <div className="p-3 modal-body mx-auto d-flex flex-column justify-content-center align-items-center">
              <span className="modal-title text-center">Are you sure you want to end the session?</span>
              <button className="submit-session d-flex justify-content-center align-items-center mt-4" onClick={Completesession}>
                <span className="submit-session-text">Yes</span>
              </button>
            </div>
          </Modal>
          {/* close start session modal */}
        </div>

      </body>
    </>


  )
}

export default Endsession